import React from 'react';
const PdpNav = ({ hasPhotos = true, hasMoreTypes }) => (React.createElement("nav", { className: "pdp_nav", id: "pdp_nav" },
    hasPhotos && (React.createElement("li", null,
        React.createElement("a", { id: "photos", href: "#photo-gallery" }, "Photo Gallery"))),
    React.createElement("li", null,
        React.createElement("a", { href: "#plant-facts", id: "facts" }, "Facts")),
    hasMoreTypes && (React.createElement("li", null,
        React.createElement("a", { href: "#more-types", id: "types" }, "More Types")))));
export default PdpNav;
